/* 
** Global Utils
*/

export const getLogo = (): string => {
  const root = document.documentElement;
  let logoSrc = root.style.getPropertyValue('--logo-emblem-uri').trim();

  if (logoSrc) {
    logoSrc = logoSrc
      .replace(/^url\(["']?/, '')
      .replace(/["']?\)$/, '');
  }

  return logoSrc;
};
